<template>
  <el-dialog title="回收站" :visible.sync="currentValue" width="60%" custom-class="recycleDialog-class" append-to-body @open="open" @opened="init">
    <template #title  v-if="show">
      <el-tabs v-model="activeName" @tab-click="tabLick">
        <el-tab-pane label="产品项" name="1"></el-tab-pane>
        <el-tab-pane label="产品系列" name="2"></el-tab-pane>
      </el-tabs>
    </template>
    <div class="content" v-loading="loading">
      <nothing v-if="!loading && tableData.length === 0"></nothing>
      <el-table
        v-else
        :data="tableData"
        row-class-name="row-class"
        @row-click="rowClick"
        style="width: 100%">
        <el-table-column
          show-overflow-tooltip
          prop="date"
          :label="activeName === '1' ? '产品项名称' : '系列名称'">
          <template #default="scope">
            <div>
              <span>{{scope.row.product_name || scope.row.series_name}}</span>
              <span v-permission="['产品项管理-更新产品项', '产品项系列管理-更新系列']" class="name letterHover" @click.stop="recover(scope.row.id)"><i class="icon iconfont iconicon_restore"></i>{{activeName == '1' ? '恢复产品项' : '恢复产品系列'}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="deleted_user"
          label="删除人">
          <template #default="scope">
            <span>{{scope.row.deleted_user ? scope.row.deleted_user.realname : '-'  }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="deleted_reason"
          label="删除原因">
          <template #default="scope">
            <span>{{scope.row.deleted_reason || '-'  }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          label="删除时间">
          <template #default="scope">
            <span>{{scope.row.delete_time ? scope.row.delete_time.replace(/-/g, '/') : '-'}}</span>
          </template>
        </el-table-column>
      </el-table>
     </div>
     <template #footer>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagData.page" :page-sizes="pagData.pageSizes" :page-size="pagData.number" :layout="pagData.layout" :total="pagData.total" hide-on-single-page>
      </el-pagination>
    </template>
  </el-dialog>
</template>
<script>
import api from '@/services/api/product/product'
export default {
  props: ['value', 'id'],
  data() {
    return {
      activeName: '1',
      show: false,
      pagData: {
        // 分页参数
        page: 1, // 页码
        pageSizes: [30, 50, 100], // 每页条数类型
        number: 30, // 每页显示条数
        layout: "prev, pager, next, sizes", // 布局
        total: 0 // 总页数
      },
      tableData: [],
      page: 1,
      per_page: 30,
      loading: true
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    },
  },
  mounted() {
  },
  methods: {
    open() {
      this.activeName = '1'
    },
    init() {
      this.show = true
      this.page = 1
      this.per_page = 30
      this.pagData = {
        page: 1,
        pageSizes: [30, 50, 100],
        number: 30,
        layout: "prev, pager, next, sizes",
        total: 0
      }
      this.getData()
    },
    handleSizeChange(val) {
      this.per_page = val
      this.page = 1
      this.getData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getData()
    },
    async getData() {
      this.loading = true
      let result = await api[this.activeName == '1' ? 'productsRecycleIndex' : 'seriesRecycleIndex']({ page: this.page, per_page: this.per_page })
      this.tableData = result.data
      this.loading = false
    },
    tabLick() {
      this.init()
    },
    async recover(id) {
      let str = this.activeName == '1' ? '产品项' : '产品系列'
      await this.$wfAlert('warning', `确认恢复${str}？`, '', '确认')
      await api[this.activeName == '1' ? 'productsRestoreProduct' : 'restoreSeries']({ id })
      this.$message({
        message: `恢复${str}成功`,
        type: 'success'
      })
      this.init()
    },
    rowClick(row) {
      this.$router.push(`/productDataIndex?id=${row.id}`)
      this.currentValue = false
    }
  }
}
</script>
<style lang="scss">
.recycleDialog-class {
  .el-dialog__body {
    min-height: 300px;
    position: relative;
  }
  .el-dialog__headerbtn {
    top: 15px;
  }
  .el-dialog {
    border-radius: 8px;
  }
  .el-dialog__header {
    padding: 0 24px;
    border-bottom: 1px solid #EEEEEE;
  }
  .el-tabs {
    .el-tabs__active-bar {
      height: 4px;
      border-radius: 2px;
      background-color: #0256FF;
    }
    .el-tabs__item {
      background-color: #fff;
    }
  }
  .content {
    .name {
      display: inline-flex;
      align-items: center;
      visibility: hidden;
      margin-left: 25px;
      i {
        font-size: 14px;
        margin-right: 9px;
      }
      font-size: 14px;
      color: #2682FF;
    }
  }
  .row-class {
    cursor: pointer;
    &:hover {
      .name {
        visibility: visible !important;
      }
    }
  }
}
</style>
